<template>
  <div class="Exportfoodwaste">
    <v-row>
      <v-col class="text-right">
            <download-excel
              :data = "papardatafoodwaste"
              type="csv"
              name="foodwaste.xls"
              >
              <v-btn type="button" color="blue white white--text">
                <span class="material-icons">file_download</span>
                {{ $t("muatturun") }} {{ $t("foodwaste") }}
              </v-btn>
            </download-excel>
      </v-col>
    </v-row>
    &nbsp;
    <v-row>
      <v-col cols="12" sm="12">
        <v-data-table
          :headers="headers"
          :items="papardatafoodwaste"
          :items-per-page="10"
          class="elevation-1"
          height="500"
          fixed-header
        >
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>
<script>

import axios from "../../plugins/axios";
import Vue from 'vue';
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);
export default {
  Name: "Exportfoodwaste",
  setup() {},
  props: [
    "papardatafoodwaste",
    "exportthn",
    "exportbln",
    "exportps",
    "paparnegeriexport",
  ],
  mounted() {},
  data: () => ({
    tokenexport: window.localStorage.getItem("tokenexport"),
    databatch: "",
    headers: [
      { text: "Bil", value: "Bil"},
      { text: "HID", value: "HID"},
      { text: "BNO", value: "BNO"},
      { text: "Pusingan", value: "Pusingan"},
      { text: "S", value: "S"},
      { text: "NG", value: "NG"},
      { text: "DP", value: "DP"},
      { text: "DB", value: "DB"},
      { text: "BP", value: "BP"},
      { text: "ST", value: "ST"},
      { text: "NOTK", value: "NOTK"},
      { text: "NOIR", value: "NOIR"},
      { text: "NOAIR", value: "NOAIR"},
      { text: "KSM", value: "KSM"},
      { text: "PBM1", value: "PBM1"},
      { text: "PBM2", value: "PBM2"},
      { text: "PBM3", value: "PBM3"},
      { text: "PBMlain", value: "PBMlain"},     
    ],
  }),
  methods: {
    async exportexcelfoodwaste(
      tokenexport,
      exportthn,
      exportbln,
      exportps,
      paparnegeriexport
    ) {
      try {
        await axios
          .post(`${process.env.VUE_APP_API_URL}/sec/checksession`, {
            tokenexportsess: window.localStorage.getItem("tokenexport"),
          })
          .then((result) => {
            console.log(result.data.status);
            if (result.data.status) {
              window.open(
                `${process.env.VUE_APP_API_URL}/foodwaste/exportfoodwasteserverside/${tokenexport}/${exportthn}/${exportbln}/${exportps}/${paparnegeriexport}/`,
                "_blank"
              );
            }
          });
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>